export const WHY_CARDS = [
  {
    icon: "Hammer",
    title: "Learn by Doing",
    desc: "Move beyond theoretical concepts with practical accounting exercises from day one — real invoices, debit notes and bank receipts.",
  },
  {
    icon: "Briefcase",
    title: "Real-World Scenarios",
    desc: "Work with simulated business transactions: e-way bills, reverse charge, ITC mismatches and rectifications.",
  },
  {
    icon: "MonitorSmartphone",
    title: "Hands-on Tally Training",
    desc: "Create companies, ledgers, vouchers, reports and reconciliations inside Tally Prime — not on slides.",
  },
  {
    icon: "FileCheck2",
    title: "GST & TDS Practice",
    desc: "Understand compliance through practical examples: challans, returns, Form 16/16A and portal workflows.",
  },
  {
    icon: "Award",
    title: "Capstone Project",
    desc: "Complete an end-to-end simulated business accounting project — a full financial year, start to finish.",
  },
  {
    icon: "Target",
    title: "Career-Focused",
    desc: "Develop skills mapped to real accounting, taxation and finance roles, with interview preparation.",
  },
];

export const CAPSTONE_STEPS = [
  { step: "01", name: "Create Company", desc: "Establish company books, configure GSTIN, PAN, TAN & financial year rules in Tally Prime." },
  { step: "02", name: "Create Ledgers", desc: "Design a 3-tier chart of accounts for debtors, creditors, expenses & fixed assets." },
  { step: "03", name: "Record Transactions", desc: "Ingest 150+ raw supplier bills, purchase orders, debit/credit notes and cash receipts." },
  { step: "04", name: "Voucher Entries", desc: "Execute sales, purchase, payment, receipt, contra and journal entries with correct allocations." },
  { step: "05", name: "GST Computation", desc: "Compute CGST, SGST & IGST, verify Input Tax Credit against GSTR-2B and settle liabilities." },
  { step: "06", name: "TDS Transactions", desc: "Deduct tax under Sec 194C/194J, generate Challan 281 and maintain compliance records." },
  { step: "07", name: "Bank Reconciliation", desc: "Match bank statement feeds against book balances and clear every discrepancy." },
  { step: "08", name: "GST/TDS Returns", desc: "Prepare GSTR-1, GSTR-3B offline files and quarterly Form 26Q e-TDS returns." },
  { step: "09", name: "P&L & Balance Sheet", desc: "Post month-end adjustments and depreciation, then compile clean financial statements." },
  { step: "10", name: "Final Business Review", desc: "Defend your books before senior CA mentors in a simulated statutory audit viva." },
];

export const CAREER_ROLES = [
  { title: "Junior Accountant", salary: "₹2.4L – ₹3.6L / yr", skills: "Vouchers, Ledger Posting, Reconciliation" },
  { title: "Accounts Executive", salary: "₹3.6L – ₹5.2L / yr", skills: "Tally Prime, Bank Rec, MIS Reporting" },
  { title: "GST Executive", salary: "₹3.8L – ₹6.0L / yr", skills: "GSTR-1, GSTR-3B, ITC Validation" },
  { title: "Tax Assistant", salary: "₹3.0L – ₹4.8L / yr", skills: "TDS 26Q, Form 16, IT Computations" },
  { title: "Tally Operator", salary: "₹2.2L – ₹3.4L / yr", skills: "Speed Entry, Inventory, Invoicing" },
  { title: "AP / AR Executive", salary: "₹3.5L – ₹5.5L / yr", skills: "Aging Analysis, Payment Cycles" },
  { title: "Finance Executive", salary: "₹4.5L – ₹7.0L / yr", skills: "Cash Flow, Trial Balance, BS Scrutiny" },
  { title: "Back-office Finance Executive", salary: "₹3.0L – ₹4.5L / yr", skills: "Documentation, Audit Prep, Payroll" },
];

export const MARQUEE_ITEMS = [
  "TALLY PRIME",
  "GST RETURN FILING",
  "TDS COMPLIANCE",
  "BANK RECONCILIATION",
  "CAPSTONE PROJECT",
  "VOUCHER ENTRIES",
  "P&L & BALANCE SHEET",
  "JOB-READY SKILLS",
];

export const JOB_POSITIONS = [
  "Accounts Trainer (Tally / GST)",
  "GST Faculty",
  "Career Counsellor",
  "Business Development Executive",
  "Content Writer — Finance",
  "Other",
];
